// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { createContext, useContext, useState } from "react";

import { IconButton, Snackbar } from "@3778.care/goban";
import CloseIcon from "@mui/icons-material/Close";

const SnackbarContext = createContext({
  addAlert: () => {},
});

const SnackbarProvider = ({ children }) => {
  const [message, setMessage] = useState([]);
  const [open, setOpen] = useState(false);
  const nodeRef = React.useRef(null);

  const addAlert = (message) => {
    setOpen(true);
    setMessage(message);
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const value = { addAlert };

  const CloseButton = () => (
    <IconButton
      aria-label="close"
      color="inherit"
      onClick={handleClose}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <SnackbarContext.Provider value={value}>
      {children}

      {message && (
        <Snackbar
          action={<CloseButton />}
          itemRef={nodeRef}
          ref={nodeRef}
          open={open}
          onClose={handleClose}
          message={message}
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
        />
      )}
    </SnackbarContext.Provider>
  );
};

const useSnackbar = () => useContext(SnackbarContext);

export { SnackbarProvider, useSnackbar };
